import type { EntityServiceResponse } from '@models';
import { api } from '@store/api';

import type { MadRobotState, Rule } from './madrobot.models';

type RulesResponse = EntityServiceResponse<Rule[], true>;
type StateResponse = EntityServiceResponse<MadRobotState, true>;

export const madRobotApi = api.injectEndpoints({
  endpoints: builder => ({
    getMadRobotRules: builder.query<Rule[], void>({
      query: () => ({ url: '/madrobot/rules' }),
      transformResponse: (response: RulesResponse) => response.data,
      providesTags: ['MadRobotRules'],
    }),

    putMadRobotRules: builder.mutation<Rule[], Rule[]>({
      query: rules => ({
        url: '/madrobot/rules',
        method: 'PUT',
        body: { rules },
      }),
      transformResponse: (response: RulesResponse) => response.data,
      invalidatesTags: ['MadRobotRules'],
    }),

    getMadRobotState: builder.query<MadRobotState, void>({
      query: () => ({ url: '/madrobot/state' }),
      transformResponse: (response: StateResponse) => response.data,
      providesTags: ['MadRobotState'],
    }),

    putMadRobotState: builder.mutation<MadRobotState, boolean>({
      query: enabled => ({
        url: '/madrobot/state',
        method: 'PUT',
        body: { enabled },
      }),
      transformResponse: (response: StateResponse) => response.data,
      invalidatesTags: ['MadRobotState'],
    }),
  }),
});

export const {
  useGetMadRobotRulesQuery,
  usePutMadRobotRulesMutation,
  useGetMadRobotStateQuery,
  usePutMadRobotStateMutation,
} = madRobotApi;
